import ConfirmationModal from '@/components/molecules/ConfirmationModal';
import { useAuthContext } from '@/context/auth/useAuthContext';

interface OrganizationRosterDeleteItemModalProps {
  downgradeConfirmationModalVisible: boolean;
  setDowngradeConfirmationModalVisible: (modalVisible: boolean) => void;
  downgradeItem: (itemId: string) => void;
  itemToDowngradeId: string;
  itemToDowngradeName: string;
  isDowngradePending: boolean;
}

const OrganizationRosterDowngradePeerSupportModal = ({
  downgradeConfirmationModalVisible,
  setDowngradeConfirmationModalVisible,
  downgradeItem,
  itemToDowngradeId,
  itemToDowngradeName,
  isDowngradePending,
}: OrganizationRosterDeleteItemModalProps) => {
  const { isSuperAdmin } = useAuthContext();

  return (
    <ConfirmationModal
      isOpen={downgradeConfirmationModalVisible}
      onClose={() => setDowngradeConfirmationModalVisible(false)}
      confirmButtonColor="extra.red"
      confirmButtonText="Downgrade"
      onConfirm={() => downgradeItem(itemToDowngradeId)}
      title="Confirm Downgrade"
      confirmLoading={isDowngradePending}
      description={`Are you sure you want to downgrade ${itemToDowngradeName}\n to Employee?`}
      isConfirmButtonDisabled={isSuperAdmin} // Disable if user is a super admin
    />
  );
};

export default OrganizationRosterDowngradePeerSupportModal;
